///////////////////////////////////////////////////

import { tabsApiConnector } from 'apiConnector/tabs/tabs';
import { ofType } from 'redux-observable';
import { EMPTY } from 'rxjs';
import { catchError, filter, ignoreElements, mergeMap } from 'rxjs/operators';
import type { EpicWithThunk } from 'state/state.common';

export function clearTabContentEpic(): EpicWithThunk {
  return (actions$, _state$, { httpClient }) => {
    const { clearTabContent } = tabsApiConnector(httpClient, 'secondaryMarketQuotes');

    return actions$.pipe(
      ofType('WORKSPACE_TAB_REMOVED'),
      filter(t => t.workspace === 'secondaryMarketQuotes'),
      mergeMap(({ id }) => clearTabContent(id).pipe(ignoreElements())),
      catchError(_ => EMPTY),
    );
  };
}
